<template>
  <u-animate-container>
    <div v-if="loading">
      <v-img
        src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1606299993153.png"
      ></v-img>
    </div>
    <div v-else>
      <front-header />
      <div class="container-section auth-form">
        <div class="max-container">
          <v-row>
            <v-col>
              <u-animate name="fadeInLeft" class="wow" delay="0.6s">
                <div class="login-left-content">
                  <h1>
                    Welcome to
                    <strong>Grow Pharma</strong>
                  </h1>
                  <p>Type in your info and let’s get started!</p>
                  <div class="image-box">
                    <img
                      src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1606300052247.png"
                      alt
                    />
                  </div>
                </div>
              </u-animate>
            </v-col>
            <v-col>
              <u-animate name="fadeInRight" class="d-flex wow" delay="0.6s">
                <div class="login-right-block">
                  <div class="login-box">
                    <ul class="login-nav">
                      <li class="active">
                        <a href="#">LOG IN</a>
                      </li>
                      <li>
                        <router-link :to="{ path: '/signup' }"
                          >Sign up</router-link
                        >
                      </li>
                    </ul>
                    <ValidationObserver
                      class="vuetify-form"
                      ref="obs"
                      v-slot="{ invalid, validated, passes }"
                    >
                      <v-form v-on:keyup.native.enter="passes(login)">
                        <v-row>
                          <v-col cols="12">
                            <VTextInput
                              v-model="email"
                              :rules="{ required: true, email }"
                              placeholder="Your Email Address"
                              label="Email Address *"
                            />
                          </v-col>

                          <v-col cols="12">
                            <ValidationProvider
                              name="confirm"
                              :rules="passwordRules"
                              v-slot="{ errors, valid }"
                            >
                              <v-text-field
                                :error-messages="errors"
                                :success="valid"
                                v-model="password"
                                :type="show ? 'text' : 'password'"
                                placeholder="Your Password"
                                label="Password *"
                                hint="Password must contain an upper case letter, a numeric character, and a special character"
                              >
                                <template v-slot:append>
                                  <v-btn
                                    icon
                                    @click="show = !show"
                                    tabindex="-1"
                                  >
                                    <v-icon v-if="show">mdi-eye</v-icon>
                                    <v-icon v-if="!show">mdi-eye-off</v-icon>
                                  </v-btn>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>

                          <v-col cols="12" class="text-center mt-5">
                            <v-btn
                              :disabled="invalid"
                              x-large
                              min-width="290"
                              min-height="50"
                              color="#FCAE00"
                              :loading="loading"
                              :dark="!invalid"
                              @click="passes(login)"
                              >LOG IN</v-btn
                            >
                          </v-col>

                          <v-col cols="12 mt-10" class="text-center">
                            <router-link
                              class="forgot-link"
                              :to="{ path: '/forgot-password' }"
                              >Forgot your password?</router-link
                            >
                          </v-col>
                        </v-row>
                      </v-form>
                    </ValidationObserver>
                  </div>
                </div>
              </u-animate>
            </v-col>
          </v-row>
        </div>
      </div>
      <front-footer />
      <div class="login-shape">
        <img
          src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1606299668242.png"
          alt
        />
      </div>
    </div>
    <!-- Cookie alert model -->
    <AcceptCookie />
  </u-animate-container>
</template>

<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
import FrontHeader from "../components/layouts/FrontHeader";
import FrontFooter from "../components/layouts/FrontFooter";
import { AuthService } from "@/services";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { VTextInput } from "@/components/inputs";
import { PANEL } from "@/constants";
import store from "../store";
import NodeRSA from "node-rsa";

export default {
  name: "Login",
  components: {
    UAnimateContainer,
    UAnimate,
    ValidationObserver,
    VTextInput,
    FrontHeader,
    FrontFooter,
    ValidationProvider,
    AcceptCookie: () => import("@/components/AcceptCookie")
  },
  data() {
    return {
      email: "",
      show: false,
      password: "",
      loading: false,
      passwordRules: {
        required: true,
        min: 8,
        max: 32,
        passwordRegex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/
      }
    };
  },
  methods: {
    async login() {
      const key = new NodeRSA(process.env.VUE_APP_PRIVATEKEY);
      this.loading = true;
      const response = await AuthService.login({
        email: this.email,
        password: key.encrypt(this.password, "base64"),
        panel: PANEL.toLowerCase()
      });
      this.loading = false;
      if (response) {
        this.$store.dispatch("user/setToken", response.data.token);
        this.$store.dispatch("user/setUser", response.data.user);
        const isBooking = store.state.user.isBooking;
        if (isBooking) {
          this.$router.push(isBooking);
        } else {
          this.$router.push("/newsfeed");
        }
      }
    }
  }
};
</script>
